import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '¿Con qué frecuencia debo visitar al ginecólogo?',
      answer: 'Se recomienda una visita anual de rutina para mujeres adultas. Sin embargo, si presentas síntomas como dolor, sangrado irregular o cualquier molestia, debes agendar una cita lo antes posible.'
    },
    {
      question: '¿A qué edad debo comenzar a visitar al ginecólogo?',
      answer: 'Se recomienda la primera visita al ginecólogo cuando inicies tu vida sexual activa. Esta primera consulta es importante para establecer buenos hábitos de salud reproductiva.'
    },
    {
      question: '¿Qué es el Papanicolaou y cada cuándo debo hacérmelo?',
      answer: 'El Papanicolaou es un estudio de detección de cáncer cervicouterino. Se recomienda realizarlo anualmente a partir de los 21 años o al inicio de la vida sexual activa. Es un procedimiento rápido y fundamental para tu salud.'
    },
    {
      question: '¿Puedo acudir a consulta durante mi periodo menstrual?',
      answer: 'Para exámenes de rutina como el Papanicolaou, es mejor agendar fuera de tu periodo. Sin embargo, si tienes una urgencia o síntomas que requieren atención inmediata, no dudes en acudir.'
    },
    {
      question: '¿Qué métodos anticonceptivos están disponibles?',
      answer: 'Existen múltiples opciones: píldoras, inyecciones, dispositivos intrauterinos (DIU), implantes, parches y métodos de barrera. En consulta evaluaremos tu caso particular para recomendarte el método más adecuado para ti.'
    },
    {
      question: '¿Cuándo debo comenzar el control prenatal?',
      answer: 'Lo ideal es iniciar el control prenatal tan pronto sospeches o confirmes tu embarazo. Las primeras semanas son cruciales para el desarrollo del bebé y para establecer un seguimiento adecuado.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-pink-50/30 to-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Preguntas frecuentes
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Resolvemos tus dudas más comunes
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-pink-400 to-blue-400 mx-auto mt-6 rounded-full"></div>
        </div>

        <div className="max-w-4xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-pink-50/50 transition-colors duration-200 cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-arrow-down-s-line text-2xl text-pink-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
